import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  borderContainer: theme => ({
    flex: 1,
    minHeight: 500,
    paddingTop: 10,
    marginTop: 10,
    borderTopWidth: 1,
    borderColor: theme.colors.VFDivider.tertiary,
  }),
  listContainer: {
    flex: 1,
  },
  listTitleContainer: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.VFDivider.tertiary,
  }),
  listTitleContainerMargined: {
    marginTop: 30,
  },
  listTitle: theme => ({
    fontSize: 16.6,
    paddingVertical: 16,
    color: theme.colors.textColorEight,
  }),
  spinner: {
    flex: 1,
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    height: Platform.OS === 'ios' ? 600 : 500,
  },
  bannerContainerStyle: {
    marginTop: 18.6,
    marginHorizontal: 0,
    minHeight: 160,
  },

  bannerDescStyle: {
    maxWidth: 270,
    fontSize: 16,
    lineHeight: 22.9,
  },
});
